function Hero() {
  return (
    <section className="hero" id="home">
      <div className="heroText">
        <p className="smallBadge">Admission Open 2026</p>

        <h1>
          Learn Better,<br />
          <span>Score Higher!</span>
        </h1>

        <p className="heroPara">
          Orion Academy is one of the best tuition classes in Colaba Mumbai
          providing concept-based teaching, personal attention, regular tests
          and doubt solving for School, Commerce and Science students.
        </p>

        <p className="seoLine">
          Coaching classes in Colaba for School, Commerce and Science students.
        </p>

        <div className="heroButtons">
          <a href="#contact">Book Free Demo</a>
          <a href="#courses" className="outlineBtn">View Batches</a>
        </div>
      </div>

      <div className="heroCard">
        <h3>Pass Directly X and XII</h3>

        <p>VCR / Regular Batches Starting From April / June 2026</p>

        <div className="heroPoints">
          <span>
            <b>👨‍🏫</b>
            Experienced Faculty
          </span>

          <span>
            <b>📋</b>
            Monthly Tests
          </span>

          <span>
            <b>👥</b>
            Personal Attention
          </span>

          <span>
            <b>❔</b>
            Doubt Solving
          </span>
        </div>
      </div>
    </section>
  );
}

export default Hero;